import { defineMessages } from 'react-intl';

export default defineMessages({
    excludedDriverx: {
        id: 'ml.quoteandbind.pa.additionalInformation.Excluded Driverx',
        defaultMessage: 'Excluded Driver {driverIndex}'
    },
    stateLicensed: {
        id: 'ml.quoteandbind.pa.additionalInformation.State Licensed',
        defaultMessage: 'State Licensed'
    },
    stateLicensedTooltipContent: {
        id: 'ml.quoteandbind.pa.additionalInformation.Select DC, Canada, US Territories or Foreign as your state licensed',
        defaultMessage: 'Select DC, Canada, US Territories or Foreign as your state licensed'
    },
    stateLicensedTooltipTitle: {
        id: 'ml.quoteandbind.pa.additionalInformation.What if I don\'t have a US license',
        defaultMessage: 'What if I don\'t have a US license'
    },
    ageFirstLicensed: {
        id: 'ml.quoteandbind.pa.additionalInformation.Age First Licensed',
        defaultMessage: 'Age First Licensed'
    },
    doublePound: {
        id: 'ml.quoteandbind.pa.additionalInformation.doublepound',
        defaultMessage: '##'
    },
    gatewayExcludedDriverX: {
        id: 'ml.quoteandbind.pa.additionalInformation.(Excluded Driver #x)',
        defaultMessage: '(Excluded Driver #{driverNumber})'
    },
    gatewayEnterEmailAddress: {
        id: 'ml.quoteandbind.pa.additionalInformation.Enter Email Address',
        defaultMessage: 'Enter Email Address'
    },
    invalidEmailId:{
        id:'ml.quoteandbind.pa.additionalInformation.invalidEmailId',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
});
